export enum GuaranteeLayouts {
  ONE = "Guarantee 01",
  TWO = "Guarantee 02",
  THREE = "Guarantee 03"
}
